const UserIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 19.5C21 16.1863 18.3137 13.5 15 13.5H9C5.68629 13.5 3 16.1863 3 19.5V21.5H21V19.5ZM9 14.5H15L15.2169 14.5046C17.8777 14.6182 20 16.8112 20 19.5V20.5H4V19.5L4.00462 19.2831C4.11818 16.6223 6.31125 14.5 9 14.5Z"
        fill="currentColor"
      />
      <path
        d="M3 21.5H2.5V22H3V21.5ZM21 21.5V22H21.5V21.5H21ZM15 14.5L15.0106 14H15V14.5ZM15.2169 14.5046L15.2382 14.005L15.2275 14.0047L15.2169 14.5046ZM20 20.5V21H20.5V20.5H20ZM4 20.5H3.5V21H4V20.5ZM4 19.5L3.5 19.4894V19.5H4ZM4.00462 19.2831L3.50496 19.2618L3.50473 19.2725L4.00462 19.2831ZM15 14C18.0376 14 20.5 16.4624 20.5 19.5H21.5C21.5 15.9101 18.5899 13 15 13V14ZM9 14H15V13H9V14ZM3.5 19.5C3.5 16.4624 5.96243 14 9 14V13C5.41015 13 2.5 15.9101 2.5 19.5H3.5ZM3.5 21.5V19.5H2.5V21.5H3.5ZM21 21H3V22H21V21ZM20.5 19.5V21.5H21.5V19.5H20.5ZM15 14H9V15H15V14ZM15.2275 14.0047L15.0106 14.0001L14.9894 14.9999L15.2062 15.0045L15.2275 14.0047ZM20.5 19.5C20.5 16.5422 18.1655 14.13 15.2382 14.0051L15.1956 15.0042C17.5899 15.1064 19.5 17.0802 19.5 19.5H20.5ZM20.5 20.5V19.5H19.5V20.5H20.5ZM4 21H20V20H4V21ZM3.5 19.5V20.5H4.5V19.5H3.5ZM3.50473 19.2725L3.50011 19.4894L4.49989 19.5106L4.50451 19.2938L3.50473 19.2725ZM9 14C6.04224 14 3.63001 16.3345 3.50507 19.2618L4.50416 19.3044C4.60635 16.9101 6.58025 15 9 15V14Z"
        fill="currentColor"
      />
      <rect x="8" y="3" width="8" height="8.5" rx="4" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}

export default UserIcon
